import screenfull from 'screenfull'
export default {
  data() {
    return {
      paramList: {}
    }
  },
  mounted() {
    this.getUrlParams()
    this.fullScreen()
    this.anonymousHandler()
    this.maxmumHandler()
  },
  methods: {
    getUrlKey(name) {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
    },
    getUrlParams() {
      // 参数持久化
      this.paramList = {}
      if (location.href.indexOf('?') > 0) {
        const paramStr = decodeURIComponent(location.href).split('?')
        if (paramStr.length) {
          const params = paramStr[1].split('&')
          params.forEach(param => {
            const arr = param.split('=')
            if (arr.length === 2) {
              this.paramList[arr[0].toLocaleLowerCase()] = arr[1]
            }
          })
        }
      }
      console.log(this.paramList)
    },
    fullScreen() {
      if (this.paramList.fullscreen) {
        // 设置可以点击后全屏
        this.showFullScreenDiv = true
        // 全屏完毕后移除参数
        delete this.paramList.fullscreen
      }
    },
    toggleFullScreen() {
      console.log('全屏')
      if (!screenfull.enabled) {
        this.$message({
          message: 'you browser can not work',
          type: 'warning'
        })
        return false
      }
      // 检查当前是不是在决策界面
      if (this.$route.path === '/dashboard') {
        // 调用决策全屏
        if (this.$store.getters.currentDecision) {
          this.$store.getters.currentDecision.handleFullScreen()
        }
      } else {
        screenfull.toggle()
      }
      this.showFullScreenDiv = false
    },
    anonymousHandler() {
      if (this.paramList.anonymous) {
        this.anonymous = true
      } else {
        this.anonymous = false
      }
    },
    maxmumHandler() {
      if (this.paramList.maxmum) {
        this.maxmum = true
      } else {
        this.maxmum = false
      }
    }
  }
}
